export default __webpack_public_path__ + "static/media/ellipse_wallet_1.9dad7059.svg";